"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResponse = exports.getPages = exports.getComment = void 0;
require("core-js/modules/es.object.keys.js");
var _lodash = _interopRequireDefault(require("lodash.find"));
var _lodash2 = _interopRequireDefault(require("lodash.groupby"));
var getResponse = exports.getResponse = function getResponse(question, responses) {
  if (!question || !responses) return null;
  var r = (0, _lodash.default)(responses, function (x) {
    return x.id === question.id;
  });
  return !!r ? r.response : null;
};
var getComment = exports.getComment = function getComment(question, responses) {
  if (!question || !responses) return null;
  var r = (0, _lodash.default)(responses, function (x) {
    return x.id === question.id;
  });
  return !!r ? r.comment : null;
};
var getPages = exports.getPages = function getPages(questions) {
  var pageObjs = (0, _lodash2.default)(questions, 'pageId');
  if (pageObjs) {
    return Object.keys(pageObjs);
  }
  return [];
};